export interface ApplicantDropdownOption {
  readonly value: string;
  readonly label: string;
}

export const RELATIONSHIP_TO_SELF_OPTIONS: readonly ApplicantDropdownOption[] = [
  { value: 'Father', label: 'Father' },
  { value: 'Mother', label: 'Mother' },
  { value: 'Daughter', label: 'Daughter' },
  { value: 'Son', label: 'Son' },
  { value: 'Spouse', label: 'Spouse' },
];

export const WHO_IS_SPONSOR_OPTIONS: readonly ApplicantDropdownOption[] = [
  { value: 'Self', label: 'Self' },
  { value: 'SponsoredbyCompany', label: 'Sponsored by Company' },
];

export const SPONSOR_TYPE_OPTIONS: readonly ApplicantDropdownOption[] = [
  { value: 'Resident', label: 'Resident' },
  { value: 'UAECitizen', label: 'UAE Citizen' },
  { value: 'EstablishmentCorporateCompany', label: 'Establishment/Corporate/Company' },
  { value: 'InvestorVisa', label: 'Investor Visa' },
  { value: 'GCCCitizen', label: 'GCC Citizen' },
];

export const SPONSOR_EMIRATE_OPTIONS: readonly ApplicantDropdownOption[] = [
  { value: 'AbuDhabi', label: 'Abu Dhabi' },
  { value: 'Dubai', label: 'Dubai' },
  { value: 'Sharjah', label: 'Sharjah' },
  { value: 'Ajman', label: 'Ajman' },
  { value: 'UmmAlQuwain', label: 'Umm Al Quwain' },
  { value: 'RasAlKhaimah', label: 'Ras Al Khaimah' },
  { value: 'Fujairah', label: 'Fujairah' },
];

export const SPONSOR_SALARY_BAND_OPTIONS: readonly ApplicantDropdownOption[] = [
  { value: 'LessThan4000AED', label: '< 4000 AED' },
  { value: 'Between4000And12000AED', label: '4000-12000 AED' },
  { value: 'GreaterThan12000AED', label: '> 12000 AED' },
];
